
import { Button, Modal, Popover, Space, Table, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import servicePath from '../config/apiUrl';
import '../static/css/CameraList.css';
const { confirm } = Modal;

function AdlList(props) {

  const [list, setList] = useState([])
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });
  //得到文章列表
  const getList = (currentPage) => {
    const key = 'getList';

    message.loading({ content: '加载数据...', key });
    axios({
      method: 'post',
      url: servicePath.queryCarpoolList,
      withCredentials: true,
      data: {
        // startDate: '2024-06-17',
        // endDate: '2024-07-17',
        departureCity: '',
        departureDate: '',
        type: 'all',
        page: currentPage ? currentPage : (tableParams.pagination?.current || 1)
      },
      header: { 'Access-Control-Allow-Origin': '*' }
    }).then(
      res => {
        if (res.data.code == 1) {
          let respData = res.data?.data || {}
          setList(respData?.list || [])

          setTableParams({
            ...tableParams,
            pagination: {
              current: respData?.currentPage || 1,
              pageSize: 20,
              total: respData?.totalCount || 0,
            },
          });
          message.success({ content: '加载数据成功！', key, duration: 2 });
        } else {
          setList([])
          message.error({ content: '加载数据失败！', key, duration: 2 });
        }
      }
    ).catch((res) => {
      console.log("err", res)
      setList([])
      message.error({ content: '加载数据失败！', key, duration: 2 });
    })
  }
  const handleTableChange = (
    pagination
  ) => {
    setTableParams({
      pagination
    });
    getList(pagination.current)
  };
  useEffect(() => {
    getList(1)
  }, [])


  //删除广告
  const deleteAdInfo = (id) => {
    confirm({
      title: '确定要该信息吗?',
      content: '如果你点击OK按钮，将会永远被删除，无法恢复。',
      onOk() {
        axios({
          url: servicePath.deleteCarpool,
          method: 'post',
          data: {
            cpId: id,
            isShow: 0
          },
          withCredentials: true,
          header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
          res => {
            message.success('删除成功')
            getList()
          }
        )
      },
      onCancel() {
        message.info('取消删除')
      },
    });

  }


  const translatedColumns = [
    { title: '拼车ID', dataIndex: 'cpId', key: 'cpId' },
    {
      title: '出发城市',
      dataIndex: 'departureCity',
      key: 'departureCity',
      render: text => <strong>{text}</strong>,
      fixed: 'left'
    },
    {
      title: '出发城市详情',
      dataIndex: 'departureCityDetail',
      key: 'departureCityDetail',
      fixed: 'left'
    },
    {
      title: '到达城市',
      dataIndex: 'arrivingCity',
      key: 'arrivingCity',
      fixed: 'left',
      render: text => <strong>{text}</strong>,
    },
    {
      title: '到达城市详情',
      dataIndex: 'arrivingCityDetail',
      key: 'arrivingCityDetail',
      fixed: 'left'
    },
    {
      title: '拼车类型', dataIndex: 'type', key: 'type', fixed: 'left',
      render: type => (
        <span style={{ color: type === '1' ? 'green' : 'blue' }}>
          {type === '1' ? '人找车' : type === '2' ? '车找人' : '其他'}
        </span>
      )
    },
    { title: '金额', dataIndex: 'money', key: 'money', fixed: 'left' },
    {
      title: '详细地址', dataIndex: 'contentData', key: 'contentData',
      render: content => (
        <Popover content={content}>
          {content.length > 30 ? `${content.substring(0, 30)}...` : content}
        </Popover>
      )
    },
    { title: '微信', dataIndex: 'wechat', key: 'wechat' },
    { title: '用户ID', dataIndex: 'user_id', key: 'user_id' },
    //   { title: '是否显示', dataIndex: 'isShow', key: 'isShow' },
    {
      title: '是否结束',
      dataIndex: 'isEnd',
      key: 'isEnd',
      render: isEnd => (
        <span style={{ color: isEnd === 1 ? 'red' : 'green' }}>
          {isEnd === 1 ? '结束' : '否'}
        </span>
      )
    },
    { title: '用户IP', dataIndex: 'user_ip', key: 'user_ip' },
    {
      title: '更新时间',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: updated_at => new Date(updated_at).toLocaleString()
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: created_at => new Date(created_at).toLocaleString()
    },
    { title: '用户名', dataIndex: 'username', key: 'username' },
    {
      title: '头像链接',
      dataIndex: 'avatar_url',
      key: 'avatar_url',
      render: avatarUrl => (
        <img style={{ width: '60px', height: 'auto' }} src={servicePath.serverUrl + avatarUrl} alt='用户头像' />
      )
    },
    { title: '出发日期', dataIndex: 'formattedDepartureDate', key: 'formattedDepartureDate' },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      render: (text, record) => (
        <Space size="middle">
          <Button onClick={() => { deleteAdInfo(record.cpId) }}>删除</Button>
        </Space>
      )
    }
  ];

  return (
    <div>
      <Table dataSource={list} bordered columns={translatedColumns} onChange={handleTableChange} pagination={tableParams.pagination} scroll={{ x: 'max-content' }} />
    </div>
  )

}

export default AdlList